import React from 'react';
import NotificationRulesSection from '../../../sections/AdminDashboard/Configuration/NotificationRules';

const NotificationRules = () => {
  return <NotificationRulesSection />;
};

export default NotificationRules;
